import { createUseQuery } from 'api/common/createUseQuery'
import { Experience, fetchExperiences } from 'api/fetchers/fetchExperiences'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useExperiences = createUseQuery({
  queryKey: ApiQueryKeys.EXPERIENCES,
  fetcher: fetchExperiences,
  selector: res => (res?.data as Experience[] | undefined) ?? ([] as Experience[]),
})
